import { render, staticRenderFns } from "./IcoAllMyLearning.vue?vue&type=template&id=0636767a"
import script from "./IcoAllMyLearning.vue?vue&type=script&lang=js"
export * from "./IcoAllMyLearning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports